module.exports = __webpack_public_path__ + "static/media/5.11b6956e.jpg";